import { LegacyRef, ReactNode } from 'react'
import cn from 'classnames/bind'

import PlainTooltip from 'app/common/ui-next/plain-tooltip'
import { iconTypes } from 'app/common/ui-next/plain-icon'

import Iconic from './Iconic'
import multiLineCellTypes from './multiLineCellTypes'
import styles from './Entry.scss'
import { isValueZero } from 'app/common/templates-next/table-template'

export { iconTypes }

const cx = cn.bind(styles)

type Props = {
  children: ReactNode
  duty?: boolean
  type?: (typeof multiLineCellTypes)[keyof typeof multiLineCellTypes]
  dipper?: boolean
  summary?: boolean
  alignLeft?: boolean
  alignRight?: boolean
  borderLeft?: boolean
  skipPadding?: boolean
  iconic?: boolean
  icon?: (typeof iconTypes)[keyof typeof iconTypes]
  sameWidthAs?: string
  paddingRight?: number
}

const Entry = ({
  children,
  duty,
  type = multiLineCellTypes.COMMON,
  dipper,
  summary,
  alignLeft,
  alignRight,
  borderLeft,
  skipPadding,
  iconic,
  icon,
  sameWidthAs,
  paddingRight,
}: Props) => {
  const classes = {
    padding: !skipPadding,
    commonType: type === multiLineCellTypes.COMMON,
    totalType: type === multiLineCellTypes.TOTAL,
    duty,
    dutyAbsent: duty === false,
    dipper,
    summary,
    alignLeft,
    alignRight,
    borderLeft,
  }

  const renderChildren = iconic ? (
    <Iconic icon={icon} sameWidthAs={sameWidthAs}>
      {children}
    </Iconic>
  ) : (
    children
  )

  return (
    <PlainTooltip content={children} hideWithoutOverflow>
      {(ref: LegacyRef<any>) => (
        <span
          className={cx(styles.root, classes, { zero: isValueZero(children) })}
          ref={ref}
          style={{ paddingRight }}
        >
          {renderChildren}
        </span>
      )}
    </PlainTooltip>
  )
}

export default Entry
